/**
 * Filtra los perfiles basado en el término de búsqueda
 * @param {Array} profiles - Array de perfiles
 * @param {string} searchTerm - Término de búsqueda
 * @returns {Array} - Array de perfiles filtrados
 */
export const filterProfiles = (profiles, searchTerm) => {
  if (!searchTerm.trim()) {
    return profiles;
  }

  const term = searchTerm.toLowerCase();
  return profiles.filter(
    (profile) =>
      profile.name?.toLowerCase().includes(term) ||
      profile.description?.toLowerCase().includes(term)
  );
};

/**
 * Valida los datos de un perfil
 * @param {Object} profile - Datos del perfil
 * @returns {Object} - Objeto con isValid y errores
 */
export const validateProfile = (profile) => {
  const errors = {};

  if (!profile.name || profile.name.trim() === '') {
    errors.name = 'El nombre es requerido';
  }

  if (profile.name && profile.name.length > 50) {
    errors.name = 'El nombre no puede exceder los 50 caracteres';
  }

  if (profile.description && profile.description.length > 255) {
    errors.description = 'La descripción no puede exceder los 255 caracteres';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

/**
 * Formatea los datos del perfil para envío a la API
 * @param {Object} profile - Datos del perfil
 * @returns {Object} - Datos formateados
 */
export const formatProfileData = (profile) => {
  return {
    name: profile.name.trim(),
    description: profile.description ? profile.description.trim() : '',
  };
};
